'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroNotification = require('./NitroNotification');

var _NitroNotification2 = _interopRequireDefault(_NitroNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroNotification2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-notification/index.js
// module id = 3023
// module chunks = 4